import { 
    Button
} from '@mantine/core';

import { 
    IconWorld
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';


export const LanguageSwitch = () => {
    const { i18n } = useTranslation();
    
    function handleLanguageSwitch() {
        const lang = i18n.language === 'en' ? "fr" : "en"
        i18n.changeLanguage(lang);
    }

    return (
        <>
            <Button
                onClick={handleLanguageSwitch}
                leftSection={<IconWorld />}
                variant="gradient" 
                gradient={{ from: '#0085eb', to: '#0078d4' }}>
                {i18n.language === 'en' ? "FR" : "EN"}
            </Button>
        </>
    )
}